import { createContext } from 'react';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

export type DeleteLifeAreaSectionContextProps = {
  onDeleteLifeAreaSection: (lifeArea: LifeArea, sectionId: ID) => void;
};

export const DeleteLifeAreaSectionContext =
  createContext<DeleteLifeAreaSectionContextProps>({
    onDeleteLifeAreaSection: () => {},
  });
